export default __webpack_public_path__ + "static/redeem_media-a448becf926c284a8a909f65fa2b5911.png";